import { useEffect, useMemo, useRef, useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";

const TEMPLATES = {
    tr: [
        (c) => `Yeni Meta ajans hesabı kuruldu · ${c}`,
        (a) => `Bakiye yüklemesi onaylandı · $${a} USDT`,
        (c) => `Google Ads hesabı aktifleştirildi · ${c}`,
        (c) => `TikTok hesabı yayına alındı · ${c}`,
        (a) => `Hacim ödülü uygulandı · %${a} komisyon`,
        (c) => `Snapchat hesabı teslim edildi · ${c}`,
    ],
    en: [
        (c) => `New Meta agency account provisioned · ${c}`,
        (a) => `Wallet top-up confirmed · $${a} USDT`,
        (c) => `Google Ads account activated · ${c}`,
        (c) => `TikTok account went live · ${c}`,
        (a) => `Volume reward applied · ${a}% fee`,
        (c) => `Snapchat account delivered · ${c}`,
    ],
    es: [
        (c) => `Nueva cuenta de agencia Meta creada · ${c}`,
        (a) => `Recarga de saldo confirmada · $${a} USDT`,
        (c) => `Cuenta de Google Ads activada · ${c}`,
        (c) => `Cuenta de TikTok activada · ${c}`,
        (a) => `Recompensa por volumen aplicada · ${a}% comisión`,
        (c) => `Cuenta de Snapchat entregada · ${c}`,
    ],
    pt: [
        (c) => `Nova conta de agência Meta criada · ${c}`,
        (a) => `Recarga de saldo confirmada · $${a} USDT`,
        (c) => `Conta do Google Ads ativada · ${c}`,
        (c) => `Conta do TikTok no ar · ${c}`,
        (a) => `Recompensa por volume aplicada · ${a}% de taxa`,
        (c) => `Conta do Snapchat entregue · ${c}`,
    ],
    ru: [
        (c) => `Новый агентский аккаунт Meta создан · ${c}`,
        (a) => `Пополнение баланса подтверждено · $${a} USDT`,
        (c) => `Аккаунт Google Ads активирован · ${c}`,
        (c) => `Аккаунт TikTok запущен · ${c}`,
        (a) => `Бонус за объём применён · комиссия ${a}%`,
        (c) => `Аккаунт Snapchat выдан · ${c}`,
    ],
};

const CITIES = ["Istanbul", "London", "Dubai", "Berlin", "Madrid", "São Paulo", "Warsaw", "Lisbon", "Amsterdam", "Singapore", "Bogotá", "Ankara"];
const AMOUNTS = ["1,200", "3,500", "6,800", "12,400", "9,250", "4,100", "18,700", "2,600"];
const FEES = ["2", "2.5", "3", "4"];
const LABEL = { tr: "Canlı operasyon akışı", en: "Live operations feed", es: "Actividad en vivo", pt: "Atividade ao vivo", ru: "Лента операций" };

function build(lang) {
    const tpls = TEMPLATES[lang] || TEMPLATES.en;
    return Array.from({ length: 10 }).map(() => {
        const idx = Math.floor(Math.random() * tpls.length);
        const isAmount = idx === 1;
        const isFee = idx === 4;
        const arg = isAmount
            ? AMOUNTS[Math.floor(Math.random() * AMOUNTS.length)]
            : isFee
              ? FEES[Math.floor(Math.random() * FEES.length)]
              : CITIES[Math.floor(Math.random() * CITIES.length)];
        return tpls[idx](arg);
    });
}

export default function ActivityTicker() {
    const { language } = useLanguage();
    const [items, setItems] = useState(() => build(language));
    const ref = useRef(null);

    useEffect(() => setItems(build(language)), [language]);

    const doubled = useMemo(() => [...items, ...items], [items]);

    return (
        <section className="border-y border-white/5 bg-white/[0.015] py-4 overflow-hidden" data-testid="activity-ticker">
            <div className="container-skala flex items-center gap-4">
                <span className="hidden sm:inline-flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.22em] text-highlight shrink-0">
                    <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-highlight opacity-60" />
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-highlight" />
                    </span>
                    {LABEL[language] || LABEL.en}
                </span>
                <div className="relative flex-1 overflow-hidden">
                    <div ref={ref} className="marquee-track flex gap-3 w-max">
                        {doubled.map((txt, i) => (
                            <span
                                key={i}
                                className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-card px-3.5 py-1.5 text-[12px] text-foreground/85 whitespace-nowrap"
                            >
                                <span className="w-1.5 h-1.5 rounded-full bg-highlight" />
                                {txt}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
